module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_1@3x.d9312764.png";